import { Directive, EmbeddedViewRef, OnDestroy, OnInit, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { AuthService } from '../../core/authentication/auth.service';
import { SubSink } from 'SubSink';
import { combineLatest } from 'rxjs';

@Directive({
  selector: '[isEmployee]',
  standalone: false
})
export class EmployeeDirective implements OnInit, OnDestroy {
  private _templateRef = inject<TemplateRef<any>>(TemplateRef);
  private _viewContainer = inject(ViewContainerRef);
  private _authService = inject(AuthService);

  private view: EmbeddedViewRef<any>;
  private subs = new SubSink();

  constructor() { }

  async ngOnInit() {
    this.subs.sink = combineLatest([this._authService.isAuthenticated$, this._authService.isEmployee$])
      .subscribe(([isAuthenticated, isEmployee]) => {
        if (isAuthenticated && isEmployee) {
          if (!this.view) {
            this.view = this._viewContainer.createEmbeddedView(this._templateRef);
          }
        } else {
          this._viewContainer.clear();
          this.view = undefined;
        }
      })
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
